// @ts-expect-error: This is how we utilize dynamic imports with WebPack NormalModuleReplacementPlugin (webpack.config.js)
import ClientImages from "./images-APP_CLIENT";
import type config from "config/config";

interface Icons {
  scannerOverlayDocFrontNoMrz: string;
  scannerOverlayDocFrontMrz: string;
  scannerOverlayDocBackNoMrz: string;
  scannerOverlayDocBackMrz: string;

  docSampleToggle: string;
  docEuro?: string;
  consentBannerIcon?: string;
  successPrimary2: string;
  scannerError: string;
  scannerWarning: string;
  burgerMenu: string;
  burgerMenuClose: string;
  paxError: string;
  edit: string;
  notFound: string;
  plane: string;
  chevron: {
    down: string;
    right: string;
    select: string;
  };
  checkMark: string;
  checkboxTick: string;
  processingCheckMark: string;
  card: {
    resolved: string;
    actionRequired: string;
    hasIssues: string;
    inProgress: string;
    info: string;
    error: string;
  };
  session: {
    resolved: string;
    actionRequired: string;
    hasIssues: string;
  };
  banner: {
    error: string;
    success: string;
    successLight: string;
    info: string;
  };
  removeFileFromList: string;
  docSelectorId: string;
  docSelectorPassport: string;
  docSelectorPdf: string;
  docSelectorVisa: string;
  docSelectorIdSelected: string;
  docSelectorPassportSelected: string;
  docSelectorPdfSelected: string;
  docSelectorVisaSelected: string;
  localeFlags?: Record<typeof config.supportedLocales[number], string>;
  localeGlobe?: string;
  clock?: string;
  pax?: string;
  externalLink?: string;
  passport?: string;
}

export interface ILocalImages {
  icons: Icons;
  passportPreview: string;
  loaderAnimation: string;
  airlineLogo: string;
  airlineLogoMobile: string;
  doneCard: string;
}

class LocalImages {
  static shared: LocalImages = new LocalImages();
  images: ILocalImages;

  constructor() {
    this.images = ClientImages;
  }
}

export default LocalImages;
